module.exports = [
	{
		"name": "effectiveDate",
		"contents": [
			{
				"dtoName": "edge.capabilities.quote.submission.base.dto.QuoteBaseDataDTO",
				"fields": [
					"PeriodStartDate"
				]
			},
			{
				"dtoName": "edge.capabilities.policyjob.lob.commercialproperty.dto.CpLobDataDTO",
				"fields": [
					"AccountOrgType"
				]
			}
		]
	},
	{
		"name": "paPrequalQuestions",
		"contents": []
	},
	{
		"name": "paDriverDetails",
		"pasFlowStepId": "PADrivers",
		"contents": [
			{
				"dtoName": "edge.capabilities.policyjob.lob.personalauto.coverables.dto.DriverDTO",
				"fields": [
					"FirstName",
					"LastName",
					"YearLicensed",
					"Violations",
					"Accidents",
					"LicenseState",
					"LicenseNumber",
					"DateOfBirth",
					"Gender"
				]
			}
		]
	},
	{
		"name": "paVehicleDetails",
		"pasFlowStepId": "PersonalVehicles",
		"contents": [
			{
				"dtoName": "edge.capabilities.policyjob.lob.personalauto.coverables.dto.VehicleDTO",
				"fields": [
					"VIN",
					"Make",
					"Model",
					"Year",
					"LicensePlate",
					"State",
					"CostNew"
				]
			}
		]
	},
	{
		"name": "puwVehicleDetails",
		"pasFlowStepId": "PUWVehicle",
		"contents": [
			{
				"dtoName": "psa.edge.capabilities.policyjob.lob.puw.coverables.dto.VehicleDTO_PSA",
				"fields": [
					"License",
					"Make",
					"Model",
					"Vin",
					"AnnualMileage",
					"VehicleType",
					"FirstRegistrationDate",
					"TypeOfEnergy",
					"CarPower",
					"NumberCylinders",
					"AuthorizedLoadedWeight",
					"VehicleSpecificities",
					"CurrentMileage",
					"MakerWarrantyEnd",
					"MakerWarrantyKilometers",
					"UsedCarSeller"
				]
			}
		]
	},
	{
		"name": "cpBuilding",
		"contents": [
			{
				"dtoName": "edge.capabilities.policyjob.lob.commercialproperty.coverables.dto.LocationDTO",
				"fields": [
					"LocationName"
				]
			},
			{
				"dtoName": "edge.capabilities.policyjob.lob.commercialproperty.coverables.dto.BuildingDTO",
				"fields": [
					"CoverageForm",
					"RateType",
					"Description",
					"YearBuilt",
					"BuildingNumber",
					"ConstructionType",
					"LocationId",
					"AddressDisplayName",
					"Exposure",
					"NumberOfStories",
					"TotalAreaExcludingBasement",
					"PercentageSprinklered",
					"AlarmType"
				]
			},
			{
				"dtoName": "edge.capabilities.propertycode.dto.ClassCodeDTO",
				"fields": [
					"Code",
					"Classification",
					"ClassCodeBasisCode"
				]
			},
			{
				"dtoName": "edge.capabilities.policycommon.coverage.dto.CoverageDTO",
				"fields": [
					"Name",
					"Updated",
					"Selected",
					"Required",
					"Description",
					"IsScheduleVisible",
					"CoverageCategoryCode",
					"CoverageCategoryDisplayName",
					"HasTerms",
					"IsValid"
				]
			}
		]
	},
	{
		"name": "wc7LocationsWizard",
		"contents": [
			{
				"entityType": "entity.PolicyLocation"
			}
		]
	},
	{
		"name": "wc7ExpModAndStateCov",
		"contents": [
			{
				"entityType": "entity.WC7Modifier"
			},
			{
				"entityType": "entity.WC7JurisdictionCov"
			}
		]
	},
	{
		"name": "wc7CoveragesAndExclusions",
		"pasFlowStepId": [
			"WC7WorkersCompLineCoverages",
			"WC7WorkersCompCoverageConfig"
		],
		"contents": [
			{
				"entityType": "entity.WC7WorkersCompCov"
			},
			{
				"entityType": "entity.WC7WorkersCompLine"
			}
		]
	},
	{
		"name": "wc7AdditionalInformation",
		"pasFlowStepId": "WC7WorkersCompCoverageConfig",
		"contents": [
			{
				"entityType": "entity.PolicyLocation"
			},
			{
				"entityType": "entity.PolicyPeriod"
			}
		]
	}
]